import Avatar from '../../components/Avatar/Avatar';
import Tooltip from '@/components/Tooltip/Tooltip';

export default {
  name: 'Avatars',
  components: {
    Avatar,
    Tooltip
  },
  props: ['users'],
  data() {
    return {
      minItems: 4
    };
  },
  computed: {
    restCollection: function() {
      return this.users
        .splice(this.minItems, this.users.length - this.minItems)
        .map(user => {
          return user.user.fullName;
        });
    },
    avatars() {
      if (this.users) {
        const showUsers =
          this.users.length > this.minItems
            ? this.users.slice(0, this.minItems)
            : this.users;

        const result = showUsers.map(user => {
          return {
            background: user.user.avatarUrl,
            title: user.user.fullName
          };
        });

        return result;
      } else {
        return [{}, {}, {}, { text: '+4' }];
      }
    }
  },
  mounted() {},
  methods: {
    showTooltip: function() {
      console.log('show it!');
      this.$refs.tooler.$el.click();
    }
  }
};
